'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('success_factor_videos', {
      url: '/success_factor_videos',
      template: '<success-factor-videos></success-factor-videos>'
    });
}
